.controls {
    position: absolute;
    inset-inline-end: var(--spacer-16);
    inset-block-end: var(--spacer-16);
    display: flex;
    gap: var(--spacer-8);
    z-index: 3;
}

.control {
    border-radius: var(--border-radius-full);
    background: var(--transparent-20);
    display: flex;
    padding: var(--spacer-12);
    justify-content: center;
    align-items: center;
    border: none;
    cursor: pointer;
    transition: background 0.2s ease;

    svg {
        width: var(--spacer-24);
        height: var(--spacer-24);
        color: var(--white);
    }

    &:hover {
        background: var(--transparent-40);
    }

    &:focus-visible {
        outline: 2px solid var(--white);
        outline-offset: 2px;
    }
}
